import React from "react";
import styles from "./IndicationComponent.module.scss";

const IndicationComponent = ({ Indication }) => {
  function getIndications(indication) {
    const ind = indication.split("\n");
    return ind;
  }
  return (
    <div className={styles.indication}>
      {getIndications(Indication).map((ind, index) => (
        <div key={index}>{ind}</div>
      ))}
    </div>
  );
};

export { IndicationComponent };
